// @flow
export const createAPIEndpoints = ({ JSON }: Object): Object => ({
	fetch: () => JSON.get('checksums.json'),
});

export default createAPIEndpoints;


// WEBPACK FOOTER //
// ./src/utils/api/checksums/index.js